<template>
  <path
    d="M14.65 4.98018L9.65 3.23018C9.23 3.08018 8.77 3.08018 8.35 3.22018L4.36 4.56018C3.55 4.84018 3 5.60018 3 6.46018V18.3102C3 19.7202 4.41 20.6802 5.72 20.1702L8.65 19.0302C8.87 18.9402 9.12 18.9402 9.34 19.0202L14.34 20.7702C14.76 20.9202 15.22 20.9202 15.64 20.7802L19.63 19.4402C20.44 19.1702 20.99 18.4002 20.99 17.5402V5.69018C20.99 4.28018 19.58 3.32018 18.27 3.83018L15.34 4.97018C15.12 5.05018 14.88 5.06018 14.65 4.98018ZM15 18.8902L9 16.7802V5.11018L15 7.22018V18.8902Z"
  />
</template>
